import {BaseModel} from '../../base/models/base-model.model';
import {ModelDate} from '../DTO/modelDate';
import {State} from '../DTO/state';

export class DomainModel extends BaseModel {
  private _certificationDate?: ModelDate;
  private _certificationState?: State;
  private _dnsConfigurationState?: State;
  /**
   * Domain External
   */
  private _external?: boolean;
  private _lastCheckDate?: ModelDate;
  /**
   * Domain Name
   */
  private _name?: string;
  private _serverConfigurationState?: State;

  constructor(certificationDate?: ModelDate, certificationState?: State, dnsConfigurationState?: State, external?: boolean, lastCheckDate?: ModelDate, name?: string, serverConfigurationState?: State) {
    super();
    this._certificationDate = certificationDate;
    this._certificationState = certificationState;
    this._dnsConfigurationState = dnsConfigurationState;
    this._external = external;
    this._lastCheckDate = lastCheckDate;
    this._name = name;
    this._serverConfigurationState = serverConfigurationState;
  }

  get certificationDate(): ModelDate {
    return this._certificationDate;
  }

  set certificationDate(value: ModelDate) {
    this._certificationDate = value;
  }

  get certificationState(): State {
    return this._certificationState;
  }

  set certificationState(value: State) {
    this._certificationState = value;
  }

  get dnsConfigurationState(): State {
    return this._dnsConfigurationState;
  }

  set dnsConfigurationState(value: State) {
    this._dnsConfigurationState = value;
  }

  get external(): boolean {
    return this._external;
  }

  set external(value: boolean) {
    this._external = value;
  }

  get lastCheckDate(): ModelDate {
    return this._lastCheckDate;
  }

  set lastCheckDate(value: ModelDate) {
    this._lastCheckDate = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get serverConfigurationState(): State {
    return this._serverConfigurationState;
  }

  set serverConfigurationState(value: State) {
    this._serverConfigurationState = value;
  }
}
